import { Button, Checkbox, Hairline } from "@components";

import styles from "@styles/home-configurations.module.scss";

import classNames from "classnames/bind";
import { useEffect, useMemo, useRef, useState } from "react";
import { If } from "shared/components/control-statements";
import { Benefit } from "shared/core/Benefit";
import { Environment } from "shared/core/Environment";
const css = classNames.bind(styles);

const buildCoupon = (coupon) => {
  const rules = Benefit.getRules(coupon);

  coupon.rules = rules;

  if (Environment.id === 51) {
    coupon.description = !coupon.description ? `${coupon.code}` : coupon.description;
  } else coupon.description = !coupon.description
    ? `${coupon.code} ${coupon.pin ? `- ${coupon.pin}` : ""}`
    : coupon.description;

  return coupon;
};

const CouponsSection = ({
  section,
  coupons,
  onChange,
  onSelect,
  onDrop,
  dropdown,
  onAddItems,
  sorting,
  onSortItems,
  onDelete,
  sortingItems,
  onCancelSorting,
  collapsedSection,
  onSelectItem,
  onDeleteItem,
}) => {
  const [collapsed, setCollapsed] = useState(sortingItems || false);

  useEffect(() => {
    if (section.id === collapsedSection) setCollapsed(true);
  }, [section, collapsedSection]);

  const couponsMap = useMemo(
    () => new Map(coupons.map((coupon) => [coupon.id, coupon])),
    [coupons]
  );

  const itemsRef = useRef(null);

  useEffect(() => {
    if (!itemsRef.current) itemsRef.current = section.items;
  }, [section.items]);

  const moveItem = (index, direction) => {
    const newIndex = index + direction;

    if (newIndex < 0 || newIndex >= (section.items || []).length) return;

    const newItems = [...section.items];
    const temp = newItems[index];
    newItems[index] = newItems[newIndex];
    newItems[newIndex] = temp;

    onChange({ ...section, items: newItems });
  };

  const builtItems = useMemo(() => {
    const coupons = (section.items || []).map((c) => {
      let coupon = couponsMap.get(c.id);

      if (!coupon) return null;

      coupon.target = c?.target;
      coupon.availability = c?.availability;

      return buildCoupon(coupon);
    });

    return coupons.filter(Boolean);
  }, [couponsMap, section.items]);

  return (
    <div
      className={css({
        section: true,
        collapsed: collapsed,
      })}
      onClick={() => setCollapsed(!collapsed)}
      key={section.id}
    >
      <div className="d-flex align-center justify-between w-100">
        <div className="d-flex align-center gap-20 w-100">
          <If cond={!sorting && !sortingItems}>
            <Checkbox
              checked={section.active}
              value={true}
              onChange={() => {
                onChange({
                  ...section,
                  active: !section.active,
                });
              }}
              disabled={!section.items || section.items.length === 0}
            />
          </If>
          <div className="d-flex align-center justify-between w-100">
            <div className="d-flex flex-column">
              <p className={styles.title}>{section.title}</p>
              <span className={styles.type}>Seção de cupons</span>
            </div>
            <If cond={sortingItems}>
              <div className="d-flex align-center">
                <Button
                  design="primary"
                  className="mr-10"
                  onClick={onCancelSorting}
                >
                  Salvar ordenação
                </Button>
                <Button
                  onClick={() => {
                    onChange({ ...section, items: itemsRef.current });
                    onCancelSorting();
                  }}
                >
                  Cancelar
                </Button>
              </div>
            </If>
          </div>
        </div>

        <If cond={!sorting && !sortingItems}>
          <div className="d-flex align-center">
            <div
              className={styles.dropdown}
              onClick={(e) => {
                onDrop(dropdown === section.id ? null : section.id);
                e.stopPropagation();
              }}
            >
              <div className={styles.action}>
                <i className="fal fa-ellipsis-v" />
              </div>

              <div
                className={css({
                  dropdownOptions: true,
                  in: dropdown === section.id,
                  out: dropdown !== section.id,
                })}
              >
                <ul className={styles.options}>
                  <li onClick={() => onSelect(section)}>Editar</li>
                  <If cond={(section.items || []).length > 0}>
                    <li onClick={() => onSortItems(section)}>Ordenar itens</li>
                  </If>
                  <li onClick={() => onDelete(section)}>Excluir</li>
                </ul>
              </div>
            </div>
            <div className={styles.hairline} />
            <div className={styles.collapse}>
              {collapsed ? (
                <i className="far fa-chevron-up" />
              ) : (
                <i className="far fa-chevron-down" />
              )}
            </div>
          </div>
        </If>
      </div>

      <If cond={collapsed}>
        <If cond={(section.items || []).length > 0}>
          <Hairline className="mt-15 mb-0" />
          <div className={styles.couponsItems}>
            {builtItems.map((item, index) => {
              return (
                <div
                  className={styles.coupon}
                  key={item.id}
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelectItem(section, item);
                  }}
                >
                  <div className="d-flex align-center">
                    <div className={styles.image}>
                      {item.image && (
                        <img
                          src={
                            process.env.REACT_APP_ASSETS_URL + `/` + item.image
                          }
                          alt=""
                        />
                      )}
                    </div>
                    <div className="d-flex flex-column">
                      <p className={styles.name}>{item.description}</p>
                      <p className={styles.rules}>
                        {item.rules.map((rule, index) => (
                          <span className={styles.rule} key={index}>
                            {rule}
                          </span>
                        ))}
                      </p>
                    </div>
                  </div>

                  <If cond={!sortingItems}>
                    <Button
                      design="default-icon-mini"
                      onClick={(e) => {
                        e.stopPropagation();
                        onSelectItem(section, item);
                      }}
                    >
                      <i className="fal fa-pen" />
                    </Button>
                    {/* <Button
                      design="default-icon-mini"
                      onClick={(e) => {
                        e.stopPropagation();
                        onDeleteItem(section, item);
                      }}
                    >
                      <i className="fal fa-trash" />
                    </Button> */}
                  </If>

                  <If cond={sortingItems}>
                    <div className="d-flex align-center gap-10">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          moveItem(index, 1);
                        }}
                        disabled={index === section?.items.length - 1}
                        type="button"
                        className={styles.moveDown}
                      >
                        <i className="fas fa-chevron-down" />
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          moveItem(index, -1);
                        }}
                        disabled={index === 0}
                        type="button"
                        className={styles.moveUp}
                      >
                        <i className="fas fa-chevron-up" />
                      </button>
                    </div>
                  </If>
                </div>
              );
            })}
          </div>
        </If>

        <If cond={!sortingItems}>
          <div className={styles.addContainer}>
            <If cond={!section.items || section.items.length === 0}>
              <p>Não existem cupons adicionados à esta seção</p>
            </If>
            <Button design="withIcon" onClick={() => onAddItems(section)}>
              <i className="far fa-plus" /> Adicionar cupom
            </Button>
          </div>
        </If>
      </If>
    </div>
  );
};

export default CouponsSection;
